import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import {formattingDate} from '../../../utils/formatting';
import styles from './styles.module.scss';

const PlansCheckDate = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    plansCheckDate,
    committeeName,
  } = context.data.pdfData;
  const plansCheckDateValue = moment(plansCheckDate).isValid() ? formattingDate(plansCheckDate) : '';

  return (
    <div ref={ref} className={styles.lastSectionLine}>
      {Boolean(plansCheckDate) && (
        <div className={classnames(styles.itemText, styles.innerPadding, styles.listItem)}>
          <span style={{paddingLeft: 10}}>ב.</span>
          {[
            'בתאריך',
            plansCheckDateValue,
            'ובמועדים קודמים נערכה בדיקה בועדה',
            'המקומית לתכנון ובניה',
            committeeName
          ].filter(Boolean).join(' ')}.
        </div>
      )}
    </div>
  );
});

export default PlansCheckDate;
